import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=658bb972&scoped=true"
import script from "./EmailDetail.vue?vue&type=script&lang=js"
export * from "./EmailDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=658bb972&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658bb972",
  null
  
)

export default component.exports